import { CheckCircle2, AlertTriangle, HelpCircle } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import type { GitCredentialStatus } from '@/types/gitRouting'

export interface CredentialStatusBadgeProps {
  status: GitCredentialStatus
}

/**
 * Whether a credential has a token. "Missing" is loud — a rule naming it is broken, not configured — and
 * "Unknown" is its own word: the store could not say, which is never the same as nothing being set.
 */
export function CredentialStatusBadge({ status }: CredentialStatusBadgeProps) {
  switch (status) {
    case 'Set':
      return (
        <Badge variant="succeeded" className="gap-1">
          <CheckCircle2 className="h-3 w-3" aria-hidden />
          Set
        </Badge>
      )
    case 'Missing':
      return (
        <Badge variant="destructive" className="gap-1">
          <AlertTriangle className="h-3 w-3" aria-hidden />
          Missing
        </Badge>
      )
    default:
      return (
        <Badge variant="outline" className="gap-1 text-muted-foreground" title="The credential store could not be read just now.">
          <HelpCircle className="h-3 w-3" aria-hidden />
          Unknown
        </Badge>
      )
  }
}
